export const config = {
  id: 'ui-designer',
  icon: 'Palette',
  color: 'pink',
  title: 'UI Designer',
  description: 'User interface design, visual design, and interaction patterns',
  department: 'Design',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 3,
    mid: 2,
    senior: 2
  }
};
